export default "__VITE_ASSET__DgzhtJ3E__"